import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nProvider";
import { PROCESS_IMG } from "@/lib/brand";

export default function HowItWorks() {
  const { t } = useI18n();
  return (
    <section id="how" data-testid="how-section" className="relative py-24 sm:py-32 bg-white/[0.02]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-5">
          <span className="text-[11px] uppercase tracking-[0.22em] font-semibold text-[#FF1F87]">
            {t.how.eyebrow}
          </span>
          <h2 className="mt-3 font-display text-4xl sm:text-5xl font-black tracking-tight">
            {t.how.title}
          </h2>

          <div className="mt-8 relative aspect-[4/5] rounded-3xl overflow-hidden border border-white/10 hidden lg:block">
            <img src={PROCESS_IMG} alt="Cleaning in action" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <div className="font-display text-2xl font-bold text-white">
                <span className="pink-text">Rosas Crew</span>
              </div>
              <p className="text-xs text-zinc-300 mt-1">Profesionales verificados • NJ</p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 space-y-5">
          {t.how.steps.map((s, idx) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, x: 24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.55, delay: idx * 0.08 }}
              data-testid={`step-${s.n}`}
              className="group relative bg-[#0A0A0A] border border-white/10 hover:border-[#EC008C]/50 rounded-3xl p-7 lg:p-8 flex items-start gap-6 transition-all hover:-translate-y-0.5"
            >
              <div className="font-display text-5xl lg:text-6xl font-black chrome-text leading-none shrink-0 group-hover:pink-text transition-colors">
                {s.n}
              </div>
              <div>
                <h3 className="font-display text-xl lg:text-2xl font-bold text-white">{s.t}</h3>
                <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{s.d}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
